import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Card,CardBody,CardHeader, List, TabContent, TabPane } from 'reactstrap';
import {Typography,Box,TextField,Button, Stack, CircularProgress} from '@mui/material';
import { useParams } from 'react-router-dom';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import AlertService from '../../services/AlertService';
import UsuarioService from '../../services/UsuarioService';
import { OptionReactSelect, Usuario, getVoidOption, setUsuarioSelect } from '../../interfaces/UsuarioSearch';
import Select from 'react-select';
import '../../App.css'
import ProductoService from '../../services/ProductoService';
import { Scopus } from '../../interfaces/Scopus';
import BusqScopusTable from './BusqScopus';
import { error } from 'console';
import { PersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const alertaService = new AlertService();
const productoService = new ProductoService();
const usuarioService = new UsuarioService();


export function BusquedaScopus() {
 const {id} = useParams();   
 const localBack : string = process.env.REACT_APP_BACK || '';
 const[listUsuario,setListUsuario] = useState<Array<PersonaInvDTO>>([]);
 const[listUser,setListUser] = useState<Array<OptionReactSelect>>([]);
 const[usuario,setUsuario] = useState('');
 const[ready,setReady] = useState(false);
 const[selectedValue, setSelectedValue] = useState('');
 const[listScopus,setListScopus] = useState<Array<Scopus>>([]);
 const[scopusResp,setScopusResp] = useState(true);

 //const casUserContext = useContext(CasUserContext);
 const casUserContext = useCasUserContext();
 const token = casUserContext.token;
 const user = casUserContext.userData;

 const searchListScopus = async (idinv:string) =>{
  alertaService.showLoading("Espere...");
  setScopusResp(false);
  //await productoService.GetListScopus(idinv,token)
  await productoService.GetListScopusSpecific(idinv,token)
  .then((data) => {
    alertaService.hideLoading();
    if(data.status.isSuccessfully) {
      alertaService.alertaExito("Exito","Se obtuvo respuesta.");
      setListScopus(data.listData);
    }else{
      alertaService.alertaAdvertencia("Alerta","No se encontraron resultados.");
  }
  })
  .catch((error) => {
    alertaService.hideLoading();
    alertaService.alertaAdvertencia("Error",error);
    console.error(error)
  });  
  setScopusResp(true);
 };

 const handleChange = (e: OptionReactSelect): void => {
  //console.log(e)
  setSelectedValue(e.value);
};

const fetchData = async () =>{
  try{     
       await usuarioService.GetListUsuarios(token)
       .then((data) => {
            //console.log(data);
            if(data.status.isSuccessfully){
              setListUsuario(data.listData);
              setListUser(setUsuarioSelect(data.listData));
              setReady(true);
            }else{
              alertaService.alertaAdvertencia("Error","No se cargaron los usuarios");
              setReady(true);
            }
        })               
       .catch((error) => console.error(error));                        
  }catch(error){
    console.error('Error:',error);
  }
};

 //Seccion Carga
 useEffect(() => {  
  fetchData();
 },[]);
 
  return (
    <Card>
        <CardHeader>
          <strong>Consulta Scopus</strong>
        </CardHeader>
        <CardBody>
        <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 1 },
          }}
          noValidate
          autoComplete="off">
            <Select
                className="app-select-react"
                classNamePrefix="select"
                defaultValue={listUser[0]}
                isDisabled={!ready}
                isLoading={!ready}
                isSearchable={ready}
                name="usuario"
                options={listUser}
                onChange={(e) => searchListScopus(e?.value || '')}
              />
          </Box> 
        {scopusResp 
        ? <BusqScopusTable rowsPerPage={[5 ,10, 25, 100]} data={listScopus} idpersona={user.idinv}/> 
        : <Stack sx={{ width: '100%' }} spacing={2}>
            <CircularProgress color="secondary" />
          </Stack>}
        </CardBody>
      </Card>
  )
}